// extracted by mini-css-extract-plugin
export var backdropBlur = "_kh-0";
export var contentCard = "_kh-5";
export var frame = "_kh-2";
export var image = "_kh-4";
export var imagePane = "_kh-3";
export var modal = "_kh-1";